import { Link as RouterLink } from 'react-router-dom'
import { styled } from 'styled-components'
import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import JsonDisplayValue from '../JsonDisplayValue'

const Link = styled(RouterLink)`
  text-decoration: none;
  color: ${(p) => p.theme.mutedText};

  &:hover {
    text-decoration: underline;
  }
`

type AutopayPlanLinkProps = {
  autopayPlanId: string
  parentObject?: any
}

const AutopayPlanLink: FC<AutopayPlanLinkProps> = ({
  autopayPlanId,
  parentObject,
}) => {
  const [_, { companyId, personId, loanId: contextLoanId }] = useQueryApi()

  // Use loanId from parentObject (e.g., from transaction) or from the route context
  const loanId = parentObject?.loanId || contextLoanId

  const link =
    companyId &&
    personId &&
    loanId &&
    `/companies/${companyId}/borrowers/${personId}/loans/${loanId}/autopay`

  if (link) {
    return (
      <JsonDisplayValue type='id'>
        <Link to={link}>{autopayPlanId}</Link>
      </JsonDisplayValue>
    )
  }

  return <JsonDisplayValue type='id'>{autopayPlanId}</JsonDisplayValue>
}

export default AutopayPlanLink
